
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M3.438 14.4h8.126c-.002 0-.002-8.638-.002-11.2H3.438v11.2zm9.75 0c0 .884-.73 1.6-1.624 1.6H3.436a1.61 1.61 0 01-1.623-1.6V3.2A.805.805 0 011 2.4c0-.442.361-.8.813-.8h4.062C5.875.716 6.603 0 7.5 0s1.625.716 1.625 1.6h4.062c.449 0 .813.355.813.8 0 .442-.36.8-.813.8v11.2zM8.311 5.598c0-.44.361-.798.813-.798.449 0 .813.357.813.798v6.404c0 .44-.361.798-.813.798a.805.805 0 01-.813-.798V5.598zm-3.25 0c0-.44.361-.798.813-.798.449 0 .813.357.813.798v6.404c0 .44-.361.798-.813.798a.805.805 0 01-.813-.798V5.598z"}})])
          )
        }
      }
    